<template>
  <div  class="cboard"
        v-if="pageState.isLoading || (!browserIsIE && dashdata && dashdata.length > 0)">

    <compare-table  :dashdata="dashdata"
                    :optionsdata="optionsdata"
                    :selection="selection"
                    :history="history"
                    :thresholds="thresholds"
                    :leadFuThresholds="leadFuThresholds"
                    :lmThresholds="lmThresholds"
                    style="padding-top: 0.125rem;"
                    v-if="!pageState.isLoading && dashdata && dashdata.length > 0" />

    <div v-if="!pageState.isLoading && dashdata && dashdata.length > 0">
      <legend-control :showTextItems="false"
                      :isBMW2020="true"
                      :thresholds="thresholds"
                      :leadFuThresholds="leadFuThresholds"
                      :lmThresholds="lmThresholds"
                      class="ti_border_dark"  />
      <icon-descriptions class="ti_border_dark" />
      <nps-legend :showSinceWhen="false" class="ti_border_dark pb-2"  />
    </div>

  </div>
  <div v-else-if="browserIsIE && !pageState.isLoading">
    <h3>{{ $t('Webportal.DashboardBMW.OtherBrowser') }}</h3>
  </div>
</template>

<script>
import BrowserDetection from '@/services/BrowserDetection';

import CompareTable from './CompareTable';
import Legend2020 from  '@/components/Dashboard-bmw/Year2021/LegendControl';
import NpsLegend from  '@/components/Dashboard-bmw/Year2020/NpsLegend';
import CompareLegendIconDescriptions from './CompareLegendIconDescriptions';

export default {
  components: {
    'compare-table': CompareTable,
    'legend-control' : Legend2020,
    'nps-legend': NpsLegend,
    'icon-descriptions': CompareLegendIconDescriptions
  },

  props:{
    dashdata: { type: Array },
    optionsdata: { type: Object },
    selection: { type: Object },
    history: { type: Array },
    thresholds: { type: Array, required: true },
    leadFuThresholds: { type: Array, required: false, default: undefined },
    lmThresholds: { type: Array, required: false, default: undefined },
    pageState: { type: Object, default: function() { return { isLoading: false }; } }
  },

  data() {
    return {
      browserIsIE: BrowserDetection.isIE()
    };
  }
}
</script>

<style lang="scss" scoped>

.cboard {
  display: grid;
  min-height: 50%;
  line-height: 1.15;
  grid-template-columns: 5fr minmax(15rem, 1fr);
  column-gap: 1rem;
}

</style>
